import { TriangleAlert, Zap, Wind } from 'lucide-react'
import { useAlertCountQuery } from '@/lib/nws/hooks'
import { useSpcQuery, useTropicsQuery, spcLevel } from './pulse-data'
import { threatColor } from '@/lib/criteria/levels'
import { hasR2 } from '@/config'
import './pulse.css'

/** Compact live national summary for the Home view (3 glanceable stats). */
export function PulseTeaser() {
  const count = useAlertCountQuery()
  const spc = useSpcQuery()
  const tropics = useTropicsQuery()

  const spcCat = spc.data?.category
  const tropicsCount = tropics.data?.length

  return (
    <div className="pulse-teaser card">
      <Stat
        icon={<TriangleAlert size={18} />}
        value={count.data ? String(count.data.total) : '—'}
        label="US alerts"
        color="var(--status-warn)"
      />
      <span className="pulse-teaser__div" />
      <Stat
        icon={<Zap size={18} />}
        value={hasR2 ? (spcCat ?? '—') : 'Set up'}
        label="Severe risk"
        color={spcCat ? threatColor(spcLevel(spcCat)) : 'var(--text-3)'}
      />
      <span className="pulse-teaser__div" />
      <Stat
        icon={<Wind size={18} />}
        value={hasR2 ? String(tropicsCount ?? 0) : 'Set up'}
        label="Tropics"
        color="var(--status-tropics)"
      />
    </div>
  )
}

function Stat({
  icon,
  value,
  label,
  color,
}: {
  icon: React.ReactNode
  value: string
  label: string
  color: string
}) {
  return (
    <div className="pulse-stat" style={{ '--c': color } as React.CSSProperties}>
      <span className="pulse-stat__icon">{icon}</span>
      <span className="pulse-stat__value num">{value}</span>
      <span className="pulse-stat__label">{label}</span>
    </div>
  )
}
